/**
 * TanStack Query hooks for `branch-network-partner-postback`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	createEvent,
	listEvents,
	branchNetworkPartnerPostbackQueryKeys,
	type CreatePostbackEventBody,
	type CreatePostbackEventResponse,
	type ListPostbackEventsParams,
	type ListPostbackEventsResponse,
} from "./api";

export function usePostbackEventsList(
	params: ListPostbackEventsParams = {},
): UseQueryResult<ListPostbackEventsResponse, Error> {
	return useQuery({
		queryKey: branchNetworkPartnerPostbackQueryKeys.list(params),
		queryFn: () => listEvents(params),
	});
}

export function usePostbackEventCreate(): UseMutationResult<
	CreatePostbackEventResponse,
	Error,
	CreatePostbackEventBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createEvent,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: branchNetworkPartnerPostbackQueryKeys.all });
		},
	});
}
